module.exports = __webpack_public_path__ + "img/5.b6e3cb7f.png";